import { tr } from "date-fns/locale";
import { removeEmptyValues } from "../../routes/scheduledJob/_function/common";
import { useMutation, useRequest } from "../../utils/api";
import { ShortMutationConfigType } from "../../utils/api.type";
import { useMe } from "../user";
import { CreateAnalyticsProps, ListAnalyticsResponse, UpdateAnalyticLayoutsProps } from "./index.type";

export const useShowAnalytics = () => {
  const { data: dataMe, isLoading: isLoadingMe } = useMe();
  const myOrganisations = dataMe?.organisation_name || "";

  // Temporary show analytics for all users until backend is ready
  // Manual Blacklist
  let isShowAnalytics = false;
  if (
    ["hitachi"].find((keyword) =>
      (dataMe?.username.toLowerCase() || "").includes(keyword)
    )
  ) {
    isShowAnalytics = false;
    return { isShowAnalytics, myOrganisations, isLoading: isLoadingMe };
  }
  if (!dataMe?.organisation_name) {
    isShowAnalytics = true;
  } else {
    isShowAnalytics = (myOrganisations &&
      ["sgh"].includes(myOrganisations.toLowerCase())) as boolean;
  }

  return {
    isShowAnalytics,
    myOrganisations,
    isLoading: isLoadingMe,
  };
};

const GET_ANALYTICS = "/v1/user_config/analytics/";
export const useAnalyticsCard = ({
  page = "job",
  enabled = true,
}: {
  page: "job" | "order";
  enabled?: boolean;
}) => {
  return useRequest<ListAnalyticsResponse>(
    GET_ANALYTICS,
    removeEmptyValues({ page }),
    {
      enabled: enabled,
    }
  );
};

const CREATE_ANALYTICS = "/v1/user_config/analytics/";
export const useCreateAnalyticsCardMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, CreateAnalyticsProps>(CREATE_ANALYTICS, options);
};

const DELETE_ANALYTICS = "/v1/user_config/analytics/:uuid/";
export const useDeleteAnalyticsCardMutation = (options: ShortMutationConfigType & { uuid: string }) => {
  return useMutation<any, any>(
    DELETE_ANALYTICS.replace(":uuid", options.uuid),
    {
      ...options,
      method: "DELETE",
    }
  );
};

const EDIT_ANALYTICS = "/v1/user_config/analytics/:uuid/";
export const useEditAnalyticsCardMutation = (options: ShortMutationConfigType & { uuid: string }) => {
  return useMutation<any, CreateAnalyticsProps>(
    EDIT_ANALYTICS.replace(":uuid", options.uuid),
    {
      ...options,
      method: "PUT",
    }
  );
};

const UPDATE_ANALYTICS_LAYOUT = "/v1/user_config/analytics/update-layouts/";
export const useUpdateAnalyticsLayoutMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, UpdateAnalyticLayoutsProps>(
    UPDATE_ANALYTICS_LAYOUT,
    {
      ...options,
      method: "POST",
    }
  );
}